/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerFindAllQueryResponse, TasksControllerFindAllQueryParams, TasksControllerFindAll401, TasksControllerFindAll403 } from "../../models/tasksController/TasksControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { tasksControllerFindAll } from "../../clients/tasksService/tasksControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const tasksControllerFindAllQueryKey = (params: TasksControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/tasks'
}, ...(params ? [params] : [])] as const;
export type TasksControllerFindAllQueryKey = ReturnType<typeof tasksControllerFindAllQueryKey>;
export function tasksControllerFindAllQueryOptions(params?: TasksControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = tasksControllerFindAllQueryKey(params);
  return queryOptions<TasksControllerFindAllQueryResponse, ResponseErrorConfig<TasksControllerFindAll401 | TasksControllerFindAll403>, TasksControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return tasksControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List tasks (filtered by scope visibility)
 * {@link /api/v1/tasks}
 */
export function useTasksControllerFindAll<TData = TasksControllerFindAllQueryResponse, TQueryData = TasksControllerFindAllQueryResponse, TQueryKey extends QueryKey = TasksControllerFindAllQueryKey>(params?: TasksControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TasksControllerFindAllQueryResponse, ResponseErrorConfig<TasksControllerFindAll401 | TasksControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? tasksControllerFindAllQueryKey(params);
  const query = useQuery({
    ...tasksControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TasksControllerFindAll401 | TasksControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}